import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { PlayFill, PauseFill } from 'react-bootstrap-icons';
import { GetStorageItem } from "../utils/storage.utils";
import defaultImage from '../assets/image/default1.png'

// import { } from "bootstrap-icons"


// const defaultImage = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4ocRnv2CKCJGSkRFb_A8Zrs-uQW17ZIODmX7t5efcZJjm6p5aMS4p2GJs&s=10'

export default function StoryCard(props: { title: string, imageURL: string, MP3File: string }) {
    const [image, setimage] = useState<string | null>(defaultImage);
    const [audioUrl, setaudioUrl] = useState<string | null>(null);


    const [currentTime, setCurrentTime] = useState<number>(0);
    const [duration, setDuration] = useState<number>(0);

    // const [audioElement, setAudioElement] = useState<HTMLAudioElement | null>(null);
    const [isPlaying, setIsPlaying] = useState<boolean>(false);

    // Use a ref to keep a single, persistent audio element instance
    const audioRef = useRef<HTMLAudioElement | null>(null);

    // Initialize audio instance when the signed URL is available
    useEffect(() => {
        if (!audioUrl) return;

        audioRef.current = new Audio(audioUrl);

        const audio = audioRef.current;

        // Track total duration once metadata loads
        const setAudioDuration = () => setDuration(audio.duration);
        // Track current time updates
        const setAudioTime = () => setCurrentTime(audio.currentTime);
        // Reset UI when audio finishes
        const handleEnded = () => setIsPlaying(false);

        audio.addEventListener('loadedmetadata', setAudioDuration);
        audio.addEventListener('timeupdate', setAudioTime);
        audio.addEventListener('ended', handleEnded);

        // Cleanup on unmount or URL change
        return () => {
            audio.pause();
            audio.removeEventListener('loadedmetadata', setAudioDuration);
            audio.removeEventListener('timeupdate', setAudioTime);
            audio.removeEventListener('ended', handleEnded);
        };
    }, [audioUrl]);

    // Handle play/pause toggles
    const handlePlayPause = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };
    // Handle timeline scrubbing
    const handleScrub = (value: string) => {
        if (!audioRef.current) return;

        const newTime = parseFloat(value);
        audioRef.current.currentTime = newTime;
        setCurrentTime(newTime);
    };

    // Helper function to format seconds into MM:SS
    const formatTime = (secs: number) => {
        if (isNaN(secs)) return '0:00';
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };


    //https://react-bootstrap.github.io/docs/components/cards

    useEffect(() => {
        GetStorageItem({ location: props.imageURL }).then((data) => {
            console.log(data)
            if (!data) return;
            // 1. Fetch the raw blob data using your existing function
            const { data: imageURL, error } = data
            if (imageURL) {
                //2. Set Image State to URL
                setimage(imageURL.signedUrl)
            }
        }).catch((error) => {

        })

        GetStorageItem({ location: props.MP3File }).then((data) => {
            console.log(data)
            if (!data) return;
            // 1. Fetch the raw blob data using your existing function
            const { data: audioURL, error } = data
            if (audioURL) {
                //2. Set Image State to URL
                setaudioUrl(audioURL.signedUrl)
            }
        })




    }, []);
    return (<>
        <Container className="-50">
            <Row className="justify-content-center h-100"> {/* Center aligned the card row */}
                <Col > {/* Wrapped Card in a Column to control its width */}
                    <Card className='h-100 '>
                        <Card.Img variant="top"
                            src={image || defaultImage || "https://placehold.co"}
                            onError={(e) => {
                                // 1. Clear onError to prevent infinite loops if the fallback link also fails
                                e.currentTarget.onerror = null;
                                // 2. Insert the final working fallback placeholder
                                e.currentTarget.src = defaultImage;
                            }}
                            style={{
                                // height: '200px',       /* Forces a fixed height */
                                maxHeight: '50%',       /* Forces a fixed height */
                                aspectRatio: 3 / 4,          /* Enforces standard portrait dimensions (e.g., 3:4 or 9:16) */
                                width: '100%',         /* Forces it to span the full card width */
                                objectFit: 'fill',    /* Prevents distortion by cropping the edges if needed */
                                backgroundColor: '#f0f0f0', /* Background color shown if the image fails to load */
                                objectPosition: 'center top'  /* Optional: keeps faces centered if it's a person's portrait */
                            }}
                        />
                        <Card.Body>
                            <Container >

                                {!audioRef.current ? <>
                                    <Row className="justify-content-center  m-4 text-center">
                                        {/* Row containing Title */}
                                        <Col xs={12}>
                                            <p className=" h5 " style={{color:'red'}}>No Audio data!</p>
                                        </Col>
                                    </Row>
                                </> :

                                    <>
                                        <Row className="justify-content-center  my-4">
                                            {/* TODO: Make triangle button circular..... somehow? */}
                                            <Button
                                                variant="light" className='playbtn border-0'
                                                // onClick={() => { alert('Story clicked') }}

                                                onClick={handlePlayPause}
                                            >
                                                {/* <PlayFill style={{ fontSize: '1.8rem' }} /> */}
                                                {isPlaying ? (
                                                    <PauseFill style={{ fontSize: '1.8rem' }} />
                                                ) : (
                                                    <PlayFill style={{ fontSize: '1.8rem' }} />
                                                )}
                                            </Button>
                                        </Row>
                                        {/* Timeline Bar Row */}
                                        <Row className="align-items-center justify-content-center">
                                            {/* Current Time */}
                                            <Col xs="auto" className="text-muted small">
                                                {formatTime(currentTime)}
                                            </Col>

                                            {/* Progress Slider */}
                                            <Col>
                                                <Form.Range
                                                    value={currentTime}
                                                    min={0}
                                                    max={duration || 100} // Fallback to 100 before duration loads
                                                    onChange={(e) => handleScrub(e.target.value)}
                                                    disabled={!audioUrl}
                                                />
                                            </Col>

                                            {/* Total Duration */}
                                            <Col xs="auto" className="text-muted small">
                                                {formatTime(duration)}
                                            </Col>
                                        </Row>

                                    </>}

                                <Row className="justify-content-center  my-2 text-center">
                                    {/* Row containing Title */}
                                    <Col xs={12}>
                                        {/* <h2>{props.title}</h2> */}
                                        <p className="h1 card_title">{props.title}</p>

                                    </Col>
                                </Row>

                                <Row className="justify-content-center  my-2 text-center">
                                    {/* Row containing Title */}
                                    <Col xs={12}>
                                        <p className="display- h4 card_subtitle" style={{}}>{props.title}</p>
                                        {/* <p className="h4">{props.title}</p> */}
                                    </Col>
                                </Row>

                                <Row className="justify-content-center  my-2 text-center">
                                    {/* Row containing Title */}
                                    <Col xs={12}>
                                        <p className="display- h4 card_subtsubitle" style={{}}>{props.title}</p>
                                        {/* <p className="h4">{props.title}</p> */}
                                    </Col>
                                </Row>
                            </Container>
                        </Card.Body>
       

                    </Card>
                </Col>
            </Row>
            {/* FIXME */}
            {/* REVIEW: test */}
            {/* NOTE */}
            {/* BUG */}
            {/* TODO: Upload to Repo */}
            {/* TODO:  Implement the separation line 
                             */}

        </Container>
    </>)

}
